<template>
  <div
    ref="scrollTable"
    class="pega-scroll-table"
    data-test="scroll-table"
    @scroll="onScroll"
  >
    <template v-if="count > countLimit">
      <paginate
        v-model="currentPage"
        :page-count="pageCount"
        :page-range="2"
        :click-handler="fetchPages"
        :prev-text="'＜'"
        :next-text="'＞'"
        :active-class="'current'"
        :container-class="'pagination'"
        :page-class="'page-item'"
        :disabled-class="'disabled'"
      />
    </template>
    <table class="boss-table-4">
      <tr class="pega-sticky entry">
        <th
          class="border pega-input"
          data-test="all-check"
          @click="checkedMax();"
        >
          <input
            type="checkbox"
            class="boss-input-checkbox"
            :checked="isSelected"
          >
        </th>
        <th>応募日</th>
        <th>応募者</th>
        <th class="is-boss-only-pc">
          求人
        </th>
        <th>
          <div
            class="pega-relative"
          >
            <span
              v-tooltip="{ content: 'スカウト（特典内容も含む）、DM送信済みの場合にアイコンが表示されます。応募期限内のものは濃色で表示、応募期限外のものは薄色で表示されます。'}"
              class="pega-circle small-right-top"
              data-test="tooltip-approach"
            >?</span>
            <div>アプローチ状況</div>
          </div>
        </th>
        <th>メッセージ</th>
        <template v-for="(displayItem) in displayItems">
          <th
            v-if="displayItem === 'phase'"
            :key="displayItem"
            class="is-boss-only-pc"
            data-test="phase"
          >
            <div class="pega-relative">
              <span
                v-tooltip="{ content: '選考フェーズの設定・編集は、「各種設定」メニューで行えます。'}"
                class="pega-circle small-right-top"
                data-test="tooltip-phase"
              >?</span>
              <div>
                選考
                <br>フェーズ
              </div>
            </div>
          </th>
          <th
            v-if="displayItem === 'status'"
            :key="displayItem"
            class="is-boss-only-pc"
            data-test="status"
          >
            <div class="pega-relative">
              <span
                v-tooltip="{ content: '選考ステータスの設定・編集は、「各種設定」メニューで行えます。'}"
                class="pega-circle small-right-top"
                data-test="tooltip-status"
              >?</span>
              <div>
                選考
                <br>ステータス
              </div>
            </div>
          </th>
          <th
            v-if="displayItem === 'remarks'"
            :key="displayItem"
            class="is-boss-only-pc"
            data-test="remarks"
          >
            備考
          </th>
          <th
            v-if="displayItem === 'responsible_staffs'"
            :key="displayItem"
            class="is-boss-only-pc"
            data-test="responsible_staffs"
          >
            人事担当
          </th>
          <th
            v-if="displayItem === 'evaluation'"
            :key="displayItem"
            class="is-boss-only-pc"
            data-test="evaluation"
          >
            評価
          </th>
          <th
            v-if="displayItem === 'comment'"
            :key="displayItem"
            class="is-boss-only-pc"
            data-test="comment"
          >
            評価コメント
          </th>
          <th
            v-if="displayItem === 'selection_date'"
            :key="displayItem"
            class="is-boss-only-pc"
            data-test="selection_date"
          >
            <div class="pega-relative">
              <span
                v-tooltip="{ content: '応募者へのリマインドメールを設定できます。'}"
                class="pega-circle small-right-top"
                data-test="tooltip-selection-date"
              >?</span>
              選考日時
            </div>
          </th>
        </template>
      </tr>
      <entry-outline
        v-for="(entryObject, key) in infinityEntryObjects"
        :key="key"
        :display-target="displayTarget"
        :entry-object="entryObject"
        :display-items="displayItems"
        @update-checked="updateChecked"
        @update-selections="updateSelections"
      />
    </table>
    <infinite-loading
      ref="infiniteLoading"
      @infinite="infiniteHandler"
    >
      <div
        slot="no-more"
        data-test="infinite-loading-no-more"
      >
        全{{ renderingEntryObjects.length }}名
      </div>
      <div slot="no-results">
        応募者がいません。
      </div>
      <div slot="spinner" />
    </infinite-loading>
    <selected-counter :checked-count="checkedCount" />
  </div>
</template>

<style scoped>
table, tr, th {
  height: 100%;
}
th > div {
  height: 100%;
  width: 100%;
}
</style>
<script>
import EntryOutline from '@/components/molecules/EntryOutline'
import SelectedCounter from '@/components/molecules/SelectedCounter'
import _ from 'lodash'
import InfiniteLoading from 'vue-infinite-loading'
import InfinityScrollIterator from '@/lib/infinityScrollIterator'
import Paginate from 'vuejs-paginate'
import { mapGetters } from 'vuex'
import { hideAllPoppers } from 'floating-vue'

export default {
  components: {
    EntryOutline,
    SelectedCounter,
    InfiniteLoading,
    Paginate
  },
  props: {
    entryObjects: {
      type: Array,
      required: true
    },
    displayTarget: {
      type: Array,
      default: () => []
    },
    count: {
      type: Number,
      required: true
    },
    countLimit: {
      type: Number,
      required: true
    },
    selectLimit: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      isSelected: false,
      infinityEntryObjects: [],
      displayItems: [],
      pastScrollTop: 0,
      currentPage: 1
    }
  },
  computed: {
    renderingEntryObjects () {
      return _(this.entryObjects)
        .filter('isShow')
        .filter('isDisplayTarget')
        .value()
    },
    checkedCount () {
      return _(this.renderingEntryObjects).filter('isChecked').value().length
    },
    ...mapGetters('settings', [
      'allStatuses'
    ]),
    pageCount () {
      return _.ceil(_.divide(this.count, this.countLimit))
    }
  },
  watch: {
    renderingEntryObjects (val) {
      if (_.has(this.$refs, 'infiniteLoading.stateChanger')) {
        this.$refs.infiniteLoading.stateChanger.reset()
      }
      this.$set(this, 'isSelected', false)
      this.infinityEntryObjects = []
      this.infinityScrollIterator = new InfinityScrollIterator(val, 50)
    }
  },
  created () {
    this.$http.secured.get('/entry/view/display_items').then(response => {
      this.$set(this, 'displayItems', response.data)
    })
  },
  methods: {
    checkedMax () {
      this.$set(this, 'isSelected', !this.isSelected)
      if (this.isSelected && this.renderingEntryObjects.length > this.selectLimit) {
        // 上から、selectLimitの件数だけ選択する
        // 実際、全件選択されていないが、利用確率が低いため、all-checkのチェックボックスはtrueでOK
        this.renderingEntryObjects.slice(0, this.selectLimit).forEach((memberObject) => {
          memberObject.isChecked = this.isSelected
        })
        this.$toasted.global.successRightTopSingleton({ message: `一括で処理できる最大数（${this.selectLimit}名）を選択しました。` })
      } else {
        // 全件操作する
        _.forEach(this.renderingEntryObjects, o => { o.isChecked = this.isSelected })
      }
    },
    updateChecked (data) {
      const index = this.renderingEntryObjects.findIndex(entryObject => entryObject.entry.id === data.id)
      this.$set(this.renderingEntryObjects[index], 'isChecked', data.isChecked)
    },
    updateSelections (val) {
      this.$http.secured.get(`/entry/view/entries/${val}/current_selection`).then(response => {
        const currentSelection = response.data
        _.set(currentSelection, 'statusOrder', this.getStatusOrder(currentSelection.statusId))
        this.$set(_.find(this.renderingEntryObjects, _.matchesProperty('entry.id', val)).entry, 'currentSelection', currentSelection)
      })
    },
    onScroll () {
      this.$set(this, 'pastScrollTop', this.$refs.scrollTable.scrollTop)
      hideAllPoppers() // 表示しているツールチップの削除
    },
    scrollTo (top) {
      this.$refs.scrollTable.scrollTo({ top })
    },
    infiniteHandler ($state) {
      if (this.infinityScrollIterator) {
        const next = this.infinityScrollIterator.next()
        if (next.done) {
          $state.complete()
        } else {
          this.infinityEntryObjects.push(...next.value)
          if (this.pastScrollTop > this.$refs.scrollTable.scrollTop) {
            this.$nextTick(() => {
              this.scrollTo(this.pastScrollTop)
            })
          }
          $state.loaded()
        }
      }
    },
    getStatusOrder (statusId) {
      return statusId ? _.findIndex(this.allStatuses, status => status.id === statusId) : null
    },
    fetchPages () {
      this.$emit('fetch')
    }
  }
}
</script>
